import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=595163b8&scoped=true"
import script from "./Notify.vue?vue&type=script&lang=js"
export * from "./Notify.vue?vue&type=script&lang=js"
import style0 from "./Notify.vue?vue&type=style&index=0&id=595163b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595163b8",
  null
  
)

export default component.exports